export class RpalSessionStorage {
    static key = 'isRpalCompleted';

    static setRpalCompleted(completed: boolean) {
        sessionStorage.setItem(this.key, `${completed}`);
    }

    static getRpalCompleted(): boolean {
        const value = sessionStorage.getItem(this.key);
        return value === 'true';
    }

    static removeRpalCompleted() {
        sessionStorage.removeItem(this.key);
    }
}
